/* Hero slider: cross-fade slides, autoplay, dot nav, pause on hover. */
(function () {
  function init(slider) {
    var slides = slider.querySelectorAll('.om-heroslider__slide');
    var dots = slider.querySelectorAll('.om-heroslider__dot');
    if (slides.length < 2) return;
    var i = 0;
    var delay = (parseInt(slider.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var timer = null;
    function show(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function start() { if (delay > 0) { stop(); timer = setInterval(function () { show(i + 1); }, delay); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-idx'), 10)); start(); });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  }
  function run() { document.querySelectorAll('.om-heroslider').forEach(init); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
